import React, { useState } from "react";
import { Dropdown, Stack, Badge, CloseButton, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { FaSearch } from "react-icons/fa";

import { onAddHsFieldsToCustomMappings } from "../../store/slices/mappingSlice";

function CustomProductMappingDropdown({
  mappedItem,
  mappings,
  hubspotDropdownFields,
  mappingsFor,
  deletedHubspotFields,
}) {
  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const {
    mapping: {
      defaultMappings: { product: productMappings },
    },
  } = useSelector((state) => state.mapping);

  /**
   * @description Creates an array of HubSpot fields mapped to the a particular economic product
   * @returns Array
   */
  const getMappedHSFields = () => {
    if (mappedItem.HS_Fields && mappedItem.HS_Fields.length > 0) {
      return mappedItem.HS_Fields.map((hsField) => hsField.HS_FieldName_CRF);
    } else {
      return [];
    }
  };

  /**
   * @description This function is responsible for searching the fields inside dropdown
   * @param {String} enteredInput input value used for searching
   */
  const searchFields = (enteredInput) => {
    setSearchInput(enteredInput);
    const searchArray = hubspotDropdownFields.filter((fieldItem) => {
      return fieldItem.HRF.toLowerCase().includes(enteredInput.toLowerCase());
    });
    setSearchResults(searchArray);
  };

  /**
   * @description Disables the fields in the dropdown that are already mapped
   * @param {String} fieldItem - HubSpot product sku value
   * @returns
   */
  const disableCheckedFields = (fieldItem) => {
    const mappedHsFields = productMappings.flatMap((mapping) =>
      mapping.HS_Fields.map((hsField) => hsField.HS_FieldName_CRF)
    );

    const isFound = mappedHsFields.includes(fieldItem);
    if (isFound) {
      return !mappedItem.HS_Fields.map(
        (hsField) => hsField.HS_FieldName_CRF
      ).includes(fieldItem);
    }

    return isFound;
  };

  return (
    <Dropdown>
      <Dropdown.Toggle className="custom-product-mapping-dropdown">
        {mappedItem?.HS_Fields && mappedItem?.HS_Fields.length > 0 ? (
          <Stack direction="horizontal" gap={2} style={{ flexWrap: "wrap" }}>
            {mappedItem.HS_Fields.map((hsField) => (
              <Badge
                key={hsField.HS_FieldName_CRF}
                className="d-flex flex-row justify-content-between"
              >
                <span className="me-2">
                  {hsField.HS_FieldName_HRF}
                  {deletedHubspotFields.includes(hsField.HS_FieldName_CRF) && (
                    <span className="error-text">(deleted)</span>
                  )}
                </span>
                <CloseButton
                  style={{ fontSize: "8px" }}
                  onClick={() =>
                    dispatch(
                      onAddHsFieldsToCustomMappings({
                        checked: false,
                        mappingsFor,
                        mappedItem,
                        selectedValue: {
                          HRF: hsField.HS_FieldName_HRF,
                          CRF: hsField.HS_FieldName_CRF,
                          type: hsField.HS_FieldType,
                          description: hsField.HS_Field_Description,
                        },
                      })
                    )
                  }
                />
              </Badge>
            ))}
          </Stack>
        ) : (
          <span style={{ fontSize: "14px" }}>Not Mapped</span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className="dropdown-container"
        renderOnMount={true}
        popperConfig={{ strategy: "fixed" }}
      >
        <div className="p-3 dropdown-search-container">
          <div className="d-flex flex-row dropdown-search-box">
            <input
              type="search"
              placeholder="search.."
              className="w-100 dropdown-search"
              onChange={(e) => searchFields(e.target.value)}
            />
            <span className="my-auto">
              <FaSearch size={15} className="me-2 search-icon" />
            </span>
          </div>
        </div>

        <div className="dropdown-items-container">
          {searchInput.length > 0 && searchResults.length === 0 && (
            <div className="d-flex flex-column justify-content-center align-items-center h-100">
              <p style={{ fontSize: "14px", fontWeight: 600 }}>
                No results found
              </p>
            </div>
          )}
          {(searchInput.length > 0 ? searchResults : hubspotDropdownFields).map(
            (fieldItem, index) => (
              <div
                key={index}
                className="px-3 py-2 custom-product-dropdown-item w-100"
              >
                <Form.Check
                  type="checkbox"
                  id={`${fieldItem.CRF}-${mappedItem.id}`}
                  label={fieldItem.HRF}
                  style={{ fontSize: "14px" }}
                  name="hubspotDropdownFields"
                  value={fieldItem.CRF}
                  disabled={disableCheckedFields(fieldItem.CRF)}
                  checked={getMappedHSFields().includes(fieldItem.CRF)}
                  onChange={(e) => {
                    dispatch(
                      onAddHsFieldsToCustomMappings({
                        checked: e.target.checked,
                        mappingsFor,
                        mappedItem,
                        selectedValue: fieldItem,
                      })
                    );
                  }}
                />
              </div>
            )
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default CustomProductMappingDropdown;
